import React from 'react';
import {
    selectedPrescripteursSelector,
    useTiersServiceSelector,
} from '@europrocurement/l2d-domain';
import {
    BoxSkeleton,
    MosaicSkeleton,
    SkeletonLoader,
    UploaderProvider,
} from '@europrocurement/flexy-components';
import { useFullLayout } from '@europrocurement/flexy-components/components/templates/FullLayout/FullLayoutContext';
import { Container } from '@mui/system';
import { DossierDocumentsProvider } from '@europrocurement/l2d-modules/providers';
import { PARCOURS_FORMALITE_CONTAINER_WIDTH, ParcoursFormaliteProvider } from './provider';
import ParcoursFormaliteOutlet from './ParcoursFormaliteOutlet';
import {
    DocumentPreviewOverlay,
    DocumentPreviewProvider,
    DocumentSignModal,
    DocumentSignModalProvider,
} from '../Dossiers';

export type ParcoursFormaliteRootProps = {
    back?: boolean;
};

const ParcoursFormaliteRoot: React.FunctionComponent<ParcoursFormaliteRootProps> = function ({
    back = false,
}) {
    const prescripteur = useTiersServiceSelector(selectedPrescripteursSelector);

    const { setSidebarOpen } = useFullLayout();
    React.useEffect(() => {
        setSidebarOpen(false);
        return () => {
            setSidebarOpen(true);
        };
    }, [setSidebarOpen]);

    return (
        <SkeletonLoader
            isLoading={!back && prescripteur === undefined}
            skeleton={
                <Container maxWidth={PARCOURS_FORMALITE_CONTAINER_WIDTH}>
                    <BoxSkeleton
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'start',
                            width: '100%',
                            height: '56px',
                            marginTop: '104px',
                        }}
                    />
                    <MosaicSkeleton
                        columns={4}
                        rows={2}
                        sx={{
                            paddingTop: '30px',
                        }}
                        sxItem={{
                            height: '153px',
                        }}
                    />
                </Container>
            }
        >
            <ParcoursFormaliteProvider
                back={back}
                prescripteur={prescripteur}
                // defaultCollectionId={373}
                // defaultDossierId={1005248}
            >
                <UploaderProvider>
                    <DossierDocumentsProvider
                        autoload
                        dossierIds={[] as unknown as number[]}
                    >
                        <DocumentSignModalProvider>
                            <DocumentPreviewProvider>
                                <ParcoursFormaliteOutlet />
                                <DocumentPreviewOverlay />
                                <DocumentSignModal />
                            </DocumentPreviewProvider>
                        </DocumentSignModalProvider>
                    </DossierDocumentsProvider>
                </UploaderProvider>
            </ParcoursFormaliteProvider>
        </SkeletonLoader>
    );
};

export default ParcoursFormaliteRoot;
